export default function getIframeDocument (iframe) {
  const iframeDocument = iframe.contentDocument || iframe.contentWindow.document

  return iframeDocument
}
